// Generates a clear bell/phone ring notification sound using Web Audio API
// Improved for restaurant environments - louder, clearer, stops on command

let currentAudioContext = null;
let currentOscillators = [];
let soundTimeout = null;

// Stop all currently playing sounds
export function stopBellSound() {
  try {
    // Clear any pending repeats
    if (soundTimeout) {
      clearTimeout(soundTimeout);
      soundTimeout = null;
    }
    
    // Stop all oscillators
    currentOscillators.forEach(osc => {
      try {
        osc.stop();
      } catch (e) {
        // Already stopped
      }
    });
    currentOscillators = [];
    
    // Close audio context
    if (currentAudioContext) {
      currentAudioContext.close();
      currentAudioContext = null;
    }
  } catch (e) {
    // Ignore errors during cleanup
  }
}

// Play a clear phone ring sound
export function playBellSound(repeat = 3) {
  try {
    // Stop any existing sound first
    stopBellSound();
    
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    
    currentAudioContext = new AudioContext();
    const ctx = currentAudioContext;
    
    const playRing = (startTime) => {
      // Main ring tone - classic phone ring
      const osc1 = ctx.createOscillator();
      const gain1 = ctx.createGain();
      osc1.type = "sine";
      osc1.frequency.setValueAtTime(440, startTime); // A4
      gain1.gain.setValueAtTime(0.4, startTime);
      gain1.gain.setValueAtTime(0.4, startTime + 0.1);
      gain1.gain.setValueAtTime(0, startTime + 0.12);
      gain1.gain.setValueAtTime(0.4, startTime + 0.14);
      gain1.gain.setValueAtTime(0.4, startTime + 0.24);
      gain1.gain.setValueAtTime(0, startTime + 0.26);
      osc1.connect(gain1);
      gain1.connect(ctx.destination);
      osc1.start(startTime);
      osc1.stop(startTime + 0.5);
      currentOscillators.push(osc1);
      
      // Second harmonic for richness
      const osc2 = ctx.createOscillator();
      const gain2 = ctx.createGain();
      osc2.type = "sine";
      osc2.frequency.setValueAtTime(480, startTime); // Slightly higher
      gain2.gain.setValueAtTime(0.3, startTime);
      gain2.gain.setValueAtTime(0.3, startTime + 0.1);
      gain2.gain.setValueAtTime(0, startTime + 0.12);
      gain2.gain.setValueAtTime(0.3, startTime + 0.14);
      gain2.gain.setValueAtTime(0.3, startTime + 0.24);
      gain2.gain.setValueAtTime(0, startTime + 0.26);
      osc2.connect(gain2);
      gain2.connect(ctx.destination);
      osc2.start(startTime);
      osc2.stop(startTime + 0.5);
      currentOscillators.push(osc2);
      
      // High bell ping for attention
      const osc3 = ctx.createOscillator();
      const gain3 = ctx.createGain();
      osc3.type = "triangle";
      osc3.frequency.setValueAtTime(880, startTime + 0.3); // A5
      gain3.gain.setValueAtTime(0.25, startTime + 0.3);
      gain3.gain.exponentialRampToValueAtTime(0.01, startTime + 0.6);
      osc3.connect(gain3);
      gain3.connect(ctx.destination);
      osc3.start(startTime + 0.3);
      osc3.stop(startTime + 0.7);
      currentOscillators.push(osc3);
    };

    // Play initial rings
    for (let i = 0; i < repeat; i++) {
      playRing(ctx.currentTime + i * 0.8);
    }
    
  } catch (e) {
    console.error("Bell sound error:", e);
  }
}

// Play continuous alert (for new orders) - stops when stopBellSound is called
export function playAlertLoop(intervalMs = 4000) {
  playBellSound(2);
  soundTimeout = setTimeout(() => playAlertLoop(intervalMs), intervalMs);
}
